import React from 'react';

function BpoCustomerExperience() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('bpo-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="bpo-cx-section">
      <div className="container bpo-cx-container">
        {/* Left Column: Content */}
        <div className="bpo-cx-left">
          <div className="bpo-cx-badge-row">
            <span className="bpo-cx-badge">Customer Experience Solutions</span>
            <div className="bpo-cx-badge-line"></div>
          </div>

          <h2 className="bpo-cx-title">
            Get Complete Customer Experience Solutions With Our BPO Services In Pakistan
          </h2>

          <p className="bpo-cx-desc">
            Experts Communication supports your business and offers you customized solutions for your operations. We simplify your customer support, telemarketing, and IT functions for the best outcomes.
          </p>

          <p className="bpo-cx-desc">
            In our business process outsourcing service, we handle these processes for you so that you can focus on growth and core business objectives. Get our call center services to take your business to another level.
          </p>

          <button className="btn-bpo-cx-action" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="bpo-cx-right">
          <div className="bpo-cx-img-wrapper">
            <img 
              src="/assets/images/service-bpo.png" 
              alt="BPO Customer Experience Solutions" 
              className="bpo-cx-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BpoCustomerExperience;
